<template>
  <el-row>
    <el-col :span="24">
      <div v-html="item.body.options[0]"></div>
    </el-col>
  </el-row>
</template>
<script>
export default {
  data() {
    return {
      value: ''
    }
  },
  methods: {
    
  },
  watch: {
    
  },
  created() {
    var _this = this
  },
  props: ['item']
}
</script>

